module.exports = __webpack_public_path__ + "img/img-6.31162538.jpg";